import { whiteColor } from '@js/material.js'

const customTabsStyle = {
  cardTitle: {
    float: 'left',
    padding: '10px 10px 10px 0px',
    lineHeight: '24px'
  },
  cardTitleRTL: {
    float: 'right',
    padding: '10px 0px 10px 10px !important'
  },
  displayNone: {
    display: 'none !important'
  },
  tabsRoot: {
    minHeight: 'unset !important',
    overflowX: 'visible',
    '& $tabRootButton': {
      fontSize: '0.875rem'
    }
  },
  tabRootButton: {
    minHeight: 'unset !important',
    minWidth: 'unset !important',
    width: 'unset !important',
    height: 'unset !important',
    maxWidth: 'unset !important',
    maxHeight: 'unset !important',
    padding: '10px 15px',
    borderRadius: '3px',
    lineHeight: '24px',
    border: '0 !important',
    color: whiteColor + ' !important',
    fontWeight: '700 !important',
    marginLeft: '4px',
    '&:last-child': {
      marginLeft: '0px'
    }
  },
  tabSelected: {
    backgroundColor: 'rgba(157, 177, 27, .5)',
    transition: '0.2s background-color 0.1s'
  },
  tabWrapper: {
    display: 'flex',
    fontSize: '12px',
    fontWeight: '700',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    '& .Icon': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginRight: 10,
      marginBottom: '0 !important',
    },
    '& svg': {
      width: 25,
      height: 25
    }
  }
}

export default customTabsStyle
